import { getValue } from "@utils/lodash";
import { formatText } from "@_common/format-text";
import React, { useEffect, useState } from "react";
import _ from "lodash";
import "./table.scss";
function SelfComplianceTable(props: any) {
  const [list, setList] = useState<any>([]);
  const [labels, setLabels] = useState([]);
  useEffect(() => {
    let array: any = [];
    let labels = getValue(props, `data`, []).map((item: object) =>
      getValue(item, `group_name`, "")
    );
    setLabels(_.uniq(labels));
    getValue(props, `data`, []).forEach((obj: any, index: number) => {
      // const mainGroupName = obj.group_name;
      const mainGroupName = getValue(obj,`group_name`, "");
      // const mainGroupLabelName = obj.group_display_name;


      const groupName = mainGroupName.replace(/[\s.]+/g, "");
      if (!array[groupName]) {
        array[groupName] = [];
      }
      const groupArray = array[groupName];
      const isDuplicate = groupArray.some(
        (item: any) =>
          getValue(item, `group_id`, "") === getValue(obj, `group_id`, "")
      );
      if (!isDuplicate) {
        array[groupName].push({
          ...obj,
        });
      }
    });
    for (const groupName in array) {
      if (array[groupName].length > 1) {
        const commonObject = {
          group_name: `${groupName} Overview`,
          group_id: "-",
          data: {
            posing: 0,
            assigned: 0,
            complied: 0,
            non_complied: 0,
            delayed: 0,
            delay_reported: 0,
            re_opened: 0,
          },
        };
        array[groupName].forEach((obj: any) => {
          commonObject.data.posing += obj.data.posing;
          commonObject.data.assigned += obj.data.assigned;
          commonObject.data.complied += obj.data.complied;
          commonObject.data.non_complied += obj.data.non_complied;
          commonObject.data.delayed += obj.data.delayed;
          commonObject.data.delay_reported += obj.data.delay_reported;
          commonObject.data.re_opened += obj.data.re_opened;
        });
        // Add the common object as the first element in the array
        array[groupName].unshift(commonObject);
      }
    }
    // Now, you have the grouped arrays with a "common" object as the first element
    setList(array);
  }, [getValue(props, `data.length`, 0) > 0]);

  /* -------------------------------------------------------------------------- */
  /*                          Accordion Section                                 */
  /* -------------------------------------------------------------------------- */

  const getGroupName = (name: string, key: any) => {
    if (name) {
      let group_name_key = name.split(":")[key];
      return group_name_key != "null" ? group_name_key : "";
    } else {
      return "";
    }
  };
  const [selectedGroup, setSelectedGroup] = useState("");
  return (
    <div className="self-compliance-container">
      {labels.map((lab: string, index: number) => {
        let newLabel = lab.replace(/[\s.]+/g, "");
        return (
          <div key={index} className="self-compliance-table-wrapper">
            <table>
              {index === 0 && (
                <thead>
                  <th>
                    <h5 className="header">Group Name</h5>
                  </th>
                  <th>
                    <h5 className="header">Assigned</h5>
                  </th>
                  <th>
                    <h5 className="header">Complied</h5>
                  </th>
                  <th>
                    <h5 className="header">Delayed</h5>
                  </th>
                  <th>
                    <h5 className="header">Delay Reported</h5>
                  </th>
                  <th>
                    <h5 className="header">Non Complied</h5>
                  </th>
                  <th>
                    <h5 className="header">Posing</h5>
                  </th>
                  <th>
                    <h5 className="header">Re Opened</h5>
                  </th>
                  <th></th>
                </thead>
              )}
              {selectedGroup !== newLabel ? (
                <tbody>
                  {getValue(list, `[${newLabel}]`, []).map(
                    (item: object, key: number) => {
                      if (key === 0)
                        return (
                          <React.Fragment>
                            <tr
                              key={key}
                              style={{
                                background:
                                  key === 0 &&
                                  getValue(list, `[${newLabel}].length`, 0) > 1
                                    ? "#f5f5f5"
                                    : "transparent",
                              }}
                            >
                              <td className="ms-3">
                                <p className="ms-3">
                                  {getValue(item, `group_display_name`, "")
                                    ? getGroupName(
                                        getValue(
                                          item,
                                          `group_display_name`,
                                          ""
                                        ),
                                        0
                                      )
                                    : getValue(item, `group_name`, "")}
                                  {getGroupName(
                                    getValue(item, `group_display_name`, ""),
                                    1
                                  ) && (
                                    <span className="p-1 graph_small_text ms-2">
                                      {getGroupName(
                                        getValue(
                                          item,
                                          `group_display_name`,
                                          ""
                                        ),
                                        1
                                      )}
                                    </span>
                                  )}
                                </p>
                              </td>
                              <td
                                onClick={() =>
                                  getValue(item, `data.assigned`, "0") > 0 &&
                                  props.handleNavigate(
                                    getValue(item, `group_id`, ""),
                                    "ASSIGNED"
                                  )
                                }
                              >
                                <p
                                  className={
                                    getValue(item, `data.assigned`, 0) !== 0 &&
                                    getValue(item, `group_id`, "") !== "-"
                                      ? "text"
                                      : "text-gray"
                                  }
                                >
                                  {getValue(item, `data.assigned`, "0")}
                                </p>
                              </td>
                              <td
                                onClick={() =>
                                  getValue(item, `data.complied`, "0") > 0 &&
                                  props.handleNavigate(
                                    getValue(item, `group_id`, ""),
                                    "COMPLIED"
                                  )
                                }
                              >
                                <p
                                  className={
                                    getValue(item, `data.complied`, 0) !== 0 &&
                                    getValue(item, `group_id`, "") !== "-"
                                      ? "text"
                                      : "text-gray"
                                  }
                                >
                                  {getValue(item, `data.complied`, "0")}
                                </p>
                              </td>
                              <td
                                onClick={() =>
                                  getValue(item, `data.delayed`, "0") > 0 &&
                                  props.handleNavigate(
                                    getValue(item, `group_id`, ""),
                                    "DELAYED"
                                  )
                                }
                              >
                                <p
                                  className={
                                    getValue(item, `data.delayed`, 0) !== 0 &&
                                    getValue(item, `group_id`, "") !== "-"
                                      ? "text"
                                      : "text-gray"
                                  }
                                >
                                  {getValue(item, `data.delayed`, "0")}
                                </p>
                              </td>
                              <td
                                onClick={() =>
                                  getValue(item, `data.delay_reported`, "0") >
                                    0 &&
                                  props.handleNavigate(
                                    getValue(item, `group_id`, ""),
                                    "DELAY_REPORTED"
                                  )
                                }
                              >
                                <p
                                  className={
                                    getValue(item, `data.delay_reported`, 0) !==
                                      0 &&
                                    getValue(item, `group_id`, "") !== "-"
                                      ? "text"
                                      : "text-gray"
                                  }
                                >
                                  {getValue(item, `data.delay_reported`, "0")}
                                </p>
                              </td>
                              <td
                                onClick={() =>
                                  getValue(item, `data.non_complied`, "0") >
                                    0 &&
                                  props.handleNavigate(
                                    getValue(item, `group_id`, ""),
                                    "NON_COMPLIED"
                                  )
                                }
                              >
                                <p
                                  className={
                                    getValue(item, `data.non_complied`, 0) !==
                                      0 &&
                                    getValue(item, `group_id`, "") !== "-"
                                      ? "text"
                                      : "text-gray"
                                  }
                                >
                                  {getValue(item, `data.non_complied`, "0")}
                                </p>
                              </td>
                              <td
                                onClick={() =>
                                  getValue(item, `data.posing`, "0") > 0 &&
                                  props.handleNavigate(
                                    getValue(item, `group_id`, ""),
                                    "POSING"
                                  )
                                }
                              >
                                <p
                                  className={
                                    getValue(item, `data.posing`, 0) !== 0 &&
                                    getValue(item, `group_id`, "") !== "-"
                                      ? "text"
                                      : "text-gray"
                                  }
                                >
                                  {" "}
                                  {getValue(item, `data.posing`, "0")}
                                </p>
                              </td>
                              <td
                                onClick={() =>
                                  getValue(item, `data.re_opened`, "0") > 0 &&
                                  props.handleNavigate(
                                    getValue(item, `group_id`, ""),
                                    "RE_OPENED"
                                  )
                                }
                              >
                                <p
                                  className={
                                    getValue(item, `data.re_opened`, 0) !== 0 &&
                                    getValue(item, `group_id`, "") !== "-"
                                      ? "text"
                                      : "text-gray"
                                  }
                                >
                                  {getValue(item, `data.re_opened`, "0")}
                                </p>
                              </td>
                              <td
                                className="cursor-pointer"
                                onClick={() =>
                                  getValue(list, `[${newLabel}].length`, 0) >
                                    0 &&
                                  setSelectedGroup(
                                    selectedGroup === newLabel ? "" : newLabel
                                  )
                                }
                              >
                                {key === 0 &&
                                  getValue(list, `[${newLabel}].length`, 0) >
                                    1 && (
                                    <img
                                      src={`/images/dashboard/tables/${
                                        selectedGroup
                                          ? selectedGroup == newLabel
                                            ? "remove-circle"
                                            : "add-circle"
                                          : "add-circle"
                                      }.svg`}
                                    />
                                  )}
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                    }
                  )}
                </tbody>
              ) : (
                <tbody>
                  {getValue(list, `[${newLabel}]`, []).map(
                    (item: object, key: number) => {
                      return (
                        <React.Fragment>
                          <tr
                            key={key}
                            style={{
                              background: key === 0 ? "#f5f5f5" : "transparent",
                            }}
                          >
                            <td className="ms-3">
                              <p className="ms-3">
                                {key === 0 ? (
                                  getValue(item, `group_name`, "")
                                ) : (
                                  <>
                                    {getValue(item, `group_display_name`, "") &&
                                      getGroupName(
                                        getValue(
                                          item,
                                          `group_display_name`,
                                          ""
                                        ),
                                        0
                                      )}
                                    {getGroupName(
                                      getValue(item, `group_display_name`, ""),
                                      1
                                    ) && (
                                      <span className="p-1 graph_small_text ms-2">
                                        {getGroupName(
                                          getValue(
                                            item,
                                            `group_display_name`,
                                            ""
                                          ),
                                          1
                                        )}
                                      </span>
                                    )}
                                  </>
                                )}
                              </p>
                            </td>
                            <td
                              onClick={() =>
                                getValue(item, `data.assigned`, "0") > 0 &&
                                props.handleNavigate(
                                  getValue(item, `group_id`, ""),
                                  "ASSIGNED"
                                )
                              }
                            >
                              <p
                                className={
                                  getValue(item, `data.assigned`, 0) !== 0 &&
                                  getValue(item, `group_id`, "") !== "-"
                                    ? "text"
                                    : "text-gray"
                                }
                              >
                                {getValue(item, `data.assigned`, "0")}
                              </p>
                            </td>
                            <td
                              onClick={() =>
                                getValue(item, `data.complied`, "0") > 0 &&
                                props.handleNavigate(
                                  getValue(item, `group_id`, ""),
                                  "COMPLIED"
                                )
                              }
                            >
                              <p
                                className={
                                  getValue(item, `data.complied`, 0) !== 0 &&
                                  getValue(item, `group_id`, "") !== "-"
                                    ? "text"
                                    : "text-gray"
                                }
                              >
                                {getValue(item, `data.complied`, "0")}
                              </p>
                            </td>
                            <td
                              onClick={() =>
                                getValue(item, `data.delayed`, "0") > 0 &&
                                props.handleNavigate(
                                  getValue(item, `group_id`, ""),
                                  "DELAYED"
                                )
                              }
                            >
                              <p
                                className={
                                  getValue(item, `data.delayed`, 0) !== 0 &&
                                  getValue(item, `group_id`, "") !== "-"
                                    ? "text"
                                    : "text-gray"
                                }
                              >
                                {getValue(item, `data.delayed`, "0")}
                              </p>
                            </td>
                            <td
                              onClick={() =>
                                getValue(item, `data.delay_reported`, "0") >
                                  0 &&
                                props.handleNavigate(
                                  getValue(item, `group_id`, ""),
                                  "DELAY_REPORTED"
                                )
                              }
                            >
                              <p
                                className={
                                  getValue(item, `data.delay_reported`, 0) !==
                                    0 && getValue(item, `group_id`, "") !== "-"
                                    ? "text"
                                    : "text-gray"
                                }
                              >
                                {getValue(item, `data.delay_reported`, "0")}
                              </p>
                            </td>
                            <td
                              onClick={() =>
                                getValue(item, `data.non_complied`, "0") > 0 &&
                                props.handleNavigate(
                                  getValue(item, `group_id`, ""),
                                  "NON_COMPLIED"
                                )
                              }
                            >
                              <p
                                className={
                                  getValue(item, `data.non_complied`, 0) !==
                                    0 && getValue(item, `group_id`, "") !== "-"
                                    ? "text"
                                    : "text-gray"
                                }
                              >
                                {getValue(item, `data.non_complied`, "0")}
                              </p>
                            </td>
                            <td
                              onClick={() =>
                                getValue(item, `data.posing`, "0") > 0 &&
                                props.handleNavigate(
                                  getValue(item, `group_id`, ""),
                                  "POSING"
                                )
                              }
                            >
                              <p
                                className={
                                  getValue(item, `data.posing`, 0) !== 0 &&
                                  getValue(item, `group_id`, "") !== "-"
                                    ? "text"
                                    : "text-gray"
                                }
                              >
                                {" "}
                                {getValue(item, `data.posing`, "0")}
                              </p>
                            </td>
                            <td
                              onClick={() =>
                                getValue(item, `data.re_opened`, "0") > 0 &&
                                props.handleNavigate(
                                  getValue(item, `group_id`, ""),
                                  "RE_OPENED"
                                )
                              }
                            >
                              <p
                                className={
                                  getValue(item, `data.re_opened`, 0) !== 0 &&
                                  getValue(item, `group_id`, "") !== "-"
                                    ? "text"
                                    : "text-gray"
                                }
                              >
                                {getValue(item, `data.re_opened`, "0")}
                              </p>
                            </td>
                            <td
                              className="cursor-pointer"
                              onClick={() =>
                                getValue(list, `[${newLabel}].length`, 0) > 0 &&
                                setSelectedGroup(
                                  selectedGroup === newLabel ? "" : newLabel
                                )
                              }
                            >
                              {key === 0 &&
                                getValue(list, `[${newLabel}].length`, 0) >
                                  1 && (
                                  <img
                                    src={`/images/dashboard/tables/${
                                      selectedGroup
                                        ? selectedGroup == newLabel
                                          ? "remove-circle"
                                          : "add-circle"
                                        : "add-circle"
                                    }.svg`}
                                  />
                                )}
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    }
                  )}
                </tbody>
              )}
            </table>
          </div>
        );
      })}
    </div>
  );
}

export default SelfComplianceTable;
